<template>
    <table class="spreadsheet-table">
      <thead>
        <tr>
          <th v-for="(col, index) in header" :key="index">
            {{ col.value }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in data" :key="rowIndex">
          <td
            v-for="(cell, cellIndex) in Object.values(row)"
            :key="cellIndex"
          >
          <div class="overlay" v-if="cell.updating">Updating...</div>
            <div v-if="typeof cell.value === 'object' && cell.value !== null">
              <div
                v-for="(line, lineIndex) in cell.value"
                :key="lineIndex"
              >
                {{ line }}
              </div>
            </div>
            <div v-else-if="!cell.editable">
              {{ cell.value }}
            </div>
            <input
              v-else
              type="text"
              v-model="cell.value"
              @focus="onFocus(cell)"
              @blur="handleCellUpdate(cell, rowIndex, cellIndex)"
              @keydown.enter="onEnter"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </template>
  
<script>
import { defineComponent, toRefs,ref } from 'vue'

export default defineComponent({
  name: 'SpreadSheet',
  props: {
    header: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  emits: ['cell-updated'],
  setup(props, { emit }) {
    const editingCell = ref(null)
    const { data } = toRefs(props) // no need to get 'header' here unless used in JS

    const handleCellUpdate = (cell, rowIndex, columnIndex) => {
        if (JSON.stringify(cell.value) === editingCell.value) return
      const updatedData = JSON.parse(JSON.stringify(data.value))
      updatedData[rowIndex][columnIndex] = { ...cell }

      emit('cell-updated', {
        cell,
        rowIndex,
        columnIndex,
        updatedData
      })
    }

    const onFocus = (cell) => {
        editingCell.value = JSON.stringify(cell.value)
    }

    const onEnter = (event) => {
        event.preventDefault()
        event.target.blur() // triggers the blur event and emits update if needed
    }

    return {
      handleCellUpdate,editingCell,onFocus,onEnter
    }
  }
})
</script>
<style scoped>
    .spreadsheet-table {width: 100%; margin: 20px 0; background: var(--white-color); border-radius: 20px; 
    padding: 20px; color: var(--black); border-collapse: collapse;}
    th, td {padding: 10px; text-align: left;}
    td {position: relative;}
    tr:nth-child(odd):not(.head){background: var(--light-row-color);}
    tr:nth-child(even){background: var(--white-color);}
    tr:nth-child(odd):not(.head):hover, tr:nth-child(odd):not(.head):hover td:nth-child(1){background: rgb(76 75 75 / 20%) !important;}
    th.sortable:hover,tr:nth-child(even):hover,tr:nth-child(even):hover td:nth-child(1){background-color: var(--white-color-hover) !important;}
  
  input {
    width: 100%;
    padding: 0;
    border: none;    background: transparent;
  }
  
  .overlay {
    position: absolute;
    inset: 0;
    background-color: rgb(0 140 255 / 70%);;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    z-index: 2;
  }
  </style>
  